module.exports = __webpack_public_path__ + "static/media/kefucaozuoliucheng.c6f1c532.png";